module.exports = __webpack_public_path__ + "static/DasaSans-Bold-75062aca9a7a55eccf53d7ecfc3de6f3.ttf";